import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookmarkIcon, CheckIcon } from 'lucide-react';
import type { School } from '../../data/mockSchools';
const difficultyMap: Record<string, {
  label: string;
  cls: string;
}> = {
  easy: {
    label: '容易',
    cls: 'bg-emerald-50 text-emerald-700'
  },
  medium: {
    label: '中等',
    cls: 'bg-amber-50 text-amber-700'
  },
  hard: {
    label: '困难',
    cls: 'bg-rose-50 text-rose-700'
  }
};
function getDifficulty(rank: number) {
  if (rank <= 10) return difficultyMap.hard;
  if (rank <= 50) return difficultyMap.medium;
  return difficultyMap.easy;
}
const advantageMajors = ['计算机科学', '金融工程', '商业分析'];
export function SchoolCard({
  s,
  saved,
  onToggleSave,
  selected,
  onToggleSelect
}: {
  s: School;
  saved: boolean;
  onToggleSave: () => void;
  selected: boolean;
  onToggleSelect: () => void;
}) {
  const nav = useNavigate();
  const diff = getDifficulty(s.rank);
  return <div className="bg-white rounded-2xl p-3 relative" data-id="element-157">
      <button onClick={() => nav(`/schools/${s.id}`)} className="w-full flex gap-3 items-start text-left" data-id="element-158">
        <div className="w-14 h-14 rounded-lg flex items-center justify-center font-bold text-xs shrink-0 border border-slate-100" style={{
        background: s.logoBg,
        color: s.logoColor || '#000'
      }} data-id="element-159">
          {s.logoText}
        </div>
        <div className="flex-1 min-w-0 pr-16" data-id="element-160">
          <div className="font-bold text-[15px] text-slate-800 truncate" data-id="element-161">
            {s.cn}
          </div>
          <div className="text-[11px] text-slate-500 truncate" data-id="element-162">{s.en}</div>
          <div className="flex items-center gap-1.5 mt-1.5 flex-wrap" data-id="element-163">
            <span className="text-[10px] bg-amber-50 text-amber-700 px-1.5 py-0.5 rounded font-semibold" data-id="element-164">
              QS #{s.rank}
            </span>
            <span className={`text-[10px] px-1.5 py-0.5 rounded font-semibold ${diff.cls}`} data-id="element-165">
              {diff.label}
            </span>
          </div>
          <div className="flex flex-wrap gap-1 mt-1.5" data-id="element-166">
            {advantageMajors.slice(0, 2).map(m => <span key={m} className="text-[10px] bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded" data-id="element-167">
                {m}
              </span>)}
          </div>
          <div className="text-[11px] text-slate-500 mt-1.5" data-id="element-168">
            {s.flag} {s.country} · {s.city}
          </div>
        </div>
      </button>

      {/* Bookmark */}
      <button onClick={onToggleSave} aria-label="收藏" className="absolute top-3 right-3 p-1" data-id="element-169">
        <BookmarkIcon size={18} className={saved ? 'text-blue-600' : 'text-slate-300'} fill={saved ? '#2b6ef5' : 'none'} data-id="element-170" />
      </button>

      {/* Compare checkbox */}
      <button onClick={onToggleSelect} aria-label="加入对比" className={`absolute bottom-3 right-3 w-5 h-5 rounded border-2 flex items-center justify-center ${selected ? 'bg-blue-600 border-blue-600' : 'bg-white border-slate-300'}`} data-id="element-171">
        {selected && <CheckIcon size={12} className="text-white" strokeWidth={3} data-id="element-172" />}
      </button>
    </div>;
}